import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    .search-bar{
        margin: 20px 0px;
    }

    .floating-button{
        position: fixed;
        z-index: 2000;
        right: 1%;
    }

    .search-form{
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
    }
`


export const ConfigurationItemContainer = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
`

export const ConfigurationItem = styled.li`
    width: 300px;
    height: 300px;
    display: flex;
    background: #e8e8e8;
    border-radius: 15px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    text-align: center;
    justify-content: center;
    align-items: center;
    color: #64c832;
    font-weight: 700;
    font-size: 32px;
    padding: 20px;
    user-select: none;
    
    &:hover{
        box-shadow: 0px 0px 16px -1px rgba(0,0,0,0.75);
    }
`
export const ErrorMessage = styled.span`
    font-size: 12px;
    color: #f44336;

`